import VueDatePicker from '@vuepic/vue-datepicker'; 
import { DateTime } from 'luxon'; 
import { baseUrl } from '../../env';
import axios from 'axios';
import '@vuepic/vue-datepicker/dist/main.css'; 
import LoadingModal from '@/components/LoadingModal.vue';
import PublicStatistics from '@/components/PublicStatistics.vue' // adjust path as needed 
import VueSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';    
export default { name: 'StatisticsPage', components: { VueDatePicker, LoadingModal, PublicStatistics, VueSelect},
data() {
    return {
        filteredData: [],
        townships: [],
        selectedTownship: null,
        date: { from: null, to: null },
        loading: false,
        loadingLabel: 'Учитавање резултата...',
        data: [],
        sortKey: 'date_money',
        sortOrder: 'desc', // only this, no sortOrders object
        from: '',
        to: '',
        publicStatisticsRef: null // Reference to PublicStatistics component
    };
},

methods: {
submit() {
    this.from = this.date.from
        ? DateTime.fromJSDate(this.date.from).toFormat('dd.MM.yyyy.')
        : '01.01.1971.';

    this.to = this.date.to
        ? DateTime.fromJSDate(this.date.to).toFormat('dd.MM.yyyy.')
        : DateTime.local().toFormat('dd.MM.yyyy.');

    // // 🔑 Push query params into URL
    // this.$router.push({
    //     query: {
    //         jedinica: this.selectedTownship ? this.selectedTownship.id : undefined,
    //         // from: this.from,
    //         // to: this.to
    //     }
    // });

    if (this.$refs.publicStatisticsRef) {
        this.$refs.publicStatisticsRef.loadAllCharts(
            this.selectedTownship,
            this.from,
            this.to
        );
    }
},

        async fetchData() {
        this.loading = true;
        try {
            const townshipsRes = await axios.get(`${baseUrl}/townships`);
            townshipsRes.data.unshift({
                name: 'Sve jedinice',
                id: 'all',
            });
            this.townships = townshipsRes.data;
        } catch (error) {
            console.error('Fetch data error:', error);
        } finally {
            this.loading = false;
        }
    }
},
async created() {
    await this.fetchData();

    // Handle jedinica param
    let selectedName = 'Sve jedinice';
    if (this.$route.query.jedinica) {
        const foundTownship = this.townships.find(
            (item) => item.id?.toString() === this.$route.query.jedinica
        );
        if (foundTownship) {
            selectedName = foundTownship.name;
        }
        this.selectedTownship = {
            id: this.$route.query.jedinica,
            name: selectedName
        };
    }

    // Handle from/to params
    if (this.$route.query.from) {
        this.date.from = DateTime.fromFormat(this.$route.query.from, 'dd.MM.yyyy.').toJSDate();
    }
    if (this.$route.query.to) {
        this.date.to = DateTime.fromFormat(this.$route.query.to, 'dd.MM.yyyy.').toJSDate();
    }
}

};
